<template>
  <div>
    <!-- standalone-->
    <home-standalone v-if="Config.STANDALONE"></home-standalone>
    <!-- fantapazz -->
    <home v-else></home>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import HomeStandalone from "./HomeStandalone";
import Home from "./Home";

export default {
  name: "home-router",
  mixins: [mixins, toast],
  components: { HomeStandalone, Home },
  mounted() {
    console.log("HomeRouter mounted.");
  },

  destroyed() {
    console.log("HomeRouter destroyed.");
  },
};
</script>